import Form from '../../components/Form';
import 'form-serializer';
import 'jquery-validation';
import VanillaModal from 'vanilla-modal';

class FormOffer extends Form {
  setupDefaults() {
    super.setupDefaults();
    this.endpoint = this.$el.attr('action');
    this.initialData = {};
    this.step = 0;
    this.dom = {
      ...this.dom,
      $submitBtn: this.$el.find('input[type="submit"]'),
      $modalForm: $('.optional-prod-details-modal-holder > form'),
      $modalCheckboxes: $('.optional-prod-details-modal-holder > form input[type=checkbox]'),
      $modalComments: $('.optional-prod-details-modal-holder .optional-prod-details__comments'),
      $modalCancelButton: $('.optional-prod-details-modal-holder .optional-prod-details__cta'),
      $modalSubmitButton: $('.optional-prod-details-modal-holder .optional-prod-details__submit'),
      $modalCloseButton: $('.optional-prod-details-modal-holder .optional-prod-details__close'),
      $nextStepButton: this.$el.find('.form-offer_form-next-step')
    };

    if (this.$el.hasClass('js-open-modal')) {
      this.modal = new VanillaModal({
        clickOutside: false,
        'class': 'modal-open'
      });
    }

    if (this.$el.parents('.form-offer-ihc').length > 0) {
      this.$el.find('.callout-field:nth-child(5)')[0].style.display = 'block';
    }

    this.$el.validate().settings.ignore = [];
  }

  addListeners() {
    this.$el.on('submit', :: this.onOfferSubmit);
    this.dom.$modalForm.on('submit', :: this.onModalSubmit);
    this.dom.$modalCancelButton.on('click', :: this.onCancelModal);
    this.dom.$modalCloseButton.on('click', :: this.onCancelModal);

    this.dom.$nextStepButton.on('click', :: this.moveToStep);
  }

  onCancelModal(e) {
    e.preventDefault();
    this.modal.close();
    this.callPostOffer(this.initialData);
  }

  onOfferSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.$el.valid()) {
      this.submitOffer();
    }
  }

  async onModalSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    this.dom.$modalSubmitButton.attr('disabled', 'disabled').parent().addClass('is-loading');

    const modalFormData = JSON.parse(this.dom.$modalForm.serializeJSON());
    const comments = this.dom.$modalComments.val();
    const checkboxes = [];

    this.dom.$modalCheckboxes.each((index, element) => {
      const $element = $(element);
      const isChecked = $element[0].checked;
      if (isChecked) {
        const text = $($element.siblings()[1]).text();
        checkboxes.push(text);
      }
    });

    const data = {
      ...modalFormData,
      ...this.initialData,
      checkboxes: checkboxes.join('&&'),
      comments: comments ? comments : ''
    }

    return await this.callPostOffer(data);
  }

  async submitOffer() {
    this.dom.$submitBtn.attr('disabled', 'disabled').parent().addClass('is-loading');
    this.clearFormLevelError();
    this.initialData = JSON.parse(this.$el.serializeJSON());
    if (this.$el.hasClass('js-open-modal')) {
      this.onOpenModal();
    } else {
      await this.callPostOffer(this.initialData);
    }
  }

  async callPostOffer(data) {
    const res = await this.postOffer(data);
    if (res.success) {
      const redirectURL = res.response.redirectUrl;
      window.location.replace(redirectURL);
    } else {
      this.clearFormLevelError();
      if (this.dom.$nextStepButton !== null) {
        this.displayFormLevelErrorFourStep(res.message);
      } else {
        this.displayFormLevelError(res.message);
      }
      this.dom.$submitBtn.removeAttr('disabled').parent().removeClass('is-loading');
      if (this.$el.hasClass('js-open-modal')) {
        this.onCloseClick();
      }
    }
  }

  postOffer(data) {
    return $.ajax({
      method: 'POST',
      url: this.endpoint,
      contentType: 'application/json',
      data: JSON.stringify(data)
    });
  }

  onOpenModal() {
    const formId = this.$el.closest('section').attr('id');
    this.modal.open(`#${formId} .optional-prod-details-modal-holder`);
  }

  onCloseClick() {
    this.modal.close();
  }

  moveToStep() {
    const inputs = Array.from(this.$el.find('.form-offer__form .callout-field'));
    const elementsToValidate = this.$el.find('input:visible');
    const validator = this.$el.validate();
    let stepIsValid = true;

    $.each(elementsToValidate, (key, value) => {
      if (!validator.element(value)) {
        stepIsValid = false;
        validator.showErrors();
      }
    });

    if (stepIsValid) {
      inputs.forEach(e => { e.style.display = 'none'; });

      const formParent = this.$el.parents('.form-offer-ihc');
      switch (this.step) {
      case 0:
        this.$el.find('.form-offer__form .callout-field:nth-child(3)')[0].style.display = 'block';
        this.step = 1;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-2');
        this.$el.find('.form-offer_form-next-step')[0].innerHTML = formParent.data('step-2Button');
        break;
      case 1:
        this.$el.find('.form-offer__form .callout-field:nth-child(1)')[0].style.display = 'block';
        this.$el.find('.form-offer__form .callout-field:nth-child(2)')[0].style.display = 'block';
        this.step = 2;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-3');
        this.$el.find('.form-offer_form-next-step')[0].innerHTML = formParent.data('step-3Button');

        break;
      case 2:
        this.$el.find('.form-offer__form .callout-field:nth-child(4)')[0].style.display = 'block';
        this.$el.find('.form-offer__form .form__submit')[0].style.display = 'block';
        this.$el.find('.form-offer_form-next-step')[0].style.display = 'none';
        this.step = 3;
        this.$el.find('.form-offer__form-step-label')[0].innerHTML = formParent.data('step-4');
        break;
      }
    }
  }

  displayFormLevelErrorFourStep(errorMessage) {
    let errorMessages = [];
    if (errorMessage.indexOf('~') !== -1) {
      errorMessages = errorMessage.split('~');
    } else {
      errorMessages.push(errorMessage);
    }

    if (typeof this.dom.$formLevelErrorContainer === 'undefined' || this.dom.$formLevelErrorContainer.length === 0) {
      const fourStepSubmitButton = this.$el.find('.form__submit.is-loading');
      $('<div class="form__global-error"></div>').insertBefore(fourStepSubmitButton);
      errorMessages.forEach(errorMsg => {
        this.dom.$formLevelErrorContainer = fourStepSubmitButton.prev('.form__global-error').append(`<p>${errorMsg}</p>`);
      });
    } else {
      errorMessages.forEach(errorMsg => {
        this.dom.$formLevelErrorContainer.append(`<p>${errorMsg}</p>`);
      });
    }
  }
}

export default FormOffer;



// WEBPACK FOOTER //
// ./src/pg/js/components/tailored_living/FormOffer.js